import { isPlatform } from '@ionic/vue';
import {
  clearPendingDeepLinkRoute,
  normalizeDeepLinkPath,
  normalizePendingDeepLinkRoute,
} from '@/utils/deeplink';

export const createRedirectUri = (packageId, domain) => {
  const isNative = isPlatform('ios') || isPlatform('android');
  const isNativeBrowser = isPlatform('mobileweb');

  return isNative && !isNativeBrowser
    ? `${packageId}://${domain}/capacitor/${packageId}/callback`
    : window.location.origin;
};

export const createLogoutUri = (packageId, domain) => {
  const isNative = isPlatform('ios') || isPlatform('android');
  const isNativeBrowser = isPlatform('mobileweb');

  return isNative && !isNativeBrowser
    ? `${packageId}://${domain}/capacitor/${packageId}/logout`
    : window.location.origin;
};
export const redirectNoAccess = router => {
  router.push('/');
};
export const redirectDeepLinkPath = (router, url) => {
  if (!url || typeof url !== 'string') {
    console.log('[redirectDeepLinkPath] Invalid URL:', url);
    return false;
  }

  try {
    console.log('[redirectDeepLinkPath] Processing URL:', url);
    const urlObj = new URL(url);
    console.log('[redirectDeepLinkPath] URL origin:', urlObj.origin);

    const appDomain = process.env.VUE_APP_APP_DOMAIN;
    if (appDomain && urlObj.origin === appDomain) {
      const params = new URLSearchParams(urlObj.search);
      const paramsObject = {};
      for (const [key, value] of params.entries()) {
        paramsObject[key] = value;
      }
      const deepLinkPathObj = {
        path: urlObj.pathname,
        query: paramsObject,
        hash: urlObj.hash,
      };
      const pendingRoute = normalizePendingDeepLinkRoute(deepLinkPathObj);
      const normalizedPath = normalizeDeepLinkPath(deepLinkPathObj.path);
      if (!normalizedPath) {
        clearPendingDeepLinkRoute();
        console.log('[redirectDeepLinkPath] Ignoring invalid internal link:', deepLinkPathObj);
        return false;
      }

      const internalRoute = pendingRoute || { ...deepLinkPathObj, path: normalizedPath };
      console.log('[redirectDeepLinkPath] Internal link - navigating to:', internalRoute);
      if (pendingRoute) {
        localStorage.setItem('deepLinkPathObj', JSON.stringify(pendingRoute));
      } else {
        clearPendingDeepLinkRoute();
      }
      router.push(internalRoute);
      return true;
    }
    console.log('[redirectDeepLinkPath] External link - not handling internally');
    return false;
  } catch (error) {
    console.error('[redirectDeepLinkPath] Error parsing URL:', error, url);
    return false;
  }
};
